<template>
  <div class="new_info_module">
    <div class="news_banner">
      <img src="../../../../static/img/news/en-newsba.jpg" alt="" width="100%">
    </div>
    <div class="news_cup">
      <div class="news_info">
        <p class="mainTitle">{{newsObj.title}}</p>
        <div class="subTitle">
          <el-form :inline="true">
            <el-form-item>
              <div>Author:{{newsObj.newsAuthor}}</div>
            </el-form-item>
            <el-form-item>
              <div>
                <span>{{newsObj.time}}</span>
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div v-html="newsObj.content" class="news_content"></div>
        <div class="news_author">Editor: {{newsObj.newsAuthor}}</div>
      </div>
      <div class="news_line">
        <el-divider></el-divider>
      </div>
      <div class="news_forecast">
        <p>
          <span>PREV:</span>
          <span @click="forecaseView(forecast.preNewsId)" class="forecast_title"> {{forecast.preNewsTitle}}</span>
        </p>
        <p>
          <span>NEXT:</span>
          <span @click="forecaseView(forecast.nextNewsId)" class="forecast_title"> {{forecast.nextNewsTitle}}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { newsInfo, forecastNews } from '@/api/enFrontApi/news';
export default {
  data() {
    return {
      newsObj: {
        title: '',
        subTitle: '',
        content: '',
        newsAuthor: '',
        time: '',
        path: ''
      },
      newsId: '',
      forecast: {
        nextNewsId: 0,
        nextNewsTitle: '',
        preNewsId: 0,
        preNewsTitle: ''
      }
    };
  },
  created() {
    this.getRouterID();
    this.getNewsInfo(this.newsId);
    this.getForecast(this.newsId);
  },
  methods: {
    getNewsInfo(newsId) {
      newsInfo({ newsId: parseInt(newsId) }).then(res => {
        this.newsObj.title = res.data.newsTitle;
        this.newsObj.subTitle = res.data.newsSubhead;
        this.newsObj.content = res.data.newsBody;
        this.newsObj.path = res.data.picMain;
        this.newsObj.time = res.data.promTime; // 发布时间
        this.newsObj.newsAuthor = res.data.newsWriter; // 图文编辑
      });
    },
    getForecast(newsId) {
      if (this.forecast.nextNewsId) {
        this.forecast.nextNewsId = 0;
        this.forecast.nextNewsTitle = '';
        this.forecast.preNewsId = 0;
        this.forecast.preNewsTitle = '';
      }
      forecastNews({ newsId: parseInt(newsId) }).then(res => {
        this.forecast.nextNewsId = res.data.nextNewsId;
        this.forecast.nextNewsTitle = res.data.nextNewsTitle;
        this.forecast.preNewsId = res.data.preNewsId;
        this.forecast.preNewsTitle = res.data.preNewsTitle;
      });
    },
    forecaseView(newsId) {
      this.$router.push({
        name: 'iaic2019en/newsInfo',
        params: {
          newsId: newsId
        }
      });
      this.newsId = newsId;
      this.getNewsInfo(newsId);
      this.getForecast(newsId);
    },
    getRouterID() {
      if (this.$route.params.newsId) {
        this.newsId = this.$route.params.newsId;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>
.new_info_module {
  width: 100%;
  min-height: 600px;
}

.news_banner {
  height: 249.42px;
}

.news_content {
  width: 95%;
  margin: 0 auto;
  background-color: #F9F9F9;
}

.news_content>>> p {
  width: 100%;
}

.news_content>>> p img {
  display: block;
  max-width: 90%;
  margin: 0 auto;
}

.news_cup {
  width: 65%;
  margin: 0px auto;
  background-color: #F9F9F9;

  .news_info {
    width: 100%;
    margin: 0 auto;
    padding: 20px 0;

    .news_author {
      float: right;
      margin-right: 50px;
    }
  }

  .news_forecast {
    font-size: 16px;
    padding-left: 20px;
    padding-bottom: 5px;

    .forecast_title {
      color: #409EFF;
      cursor: pointer;
    }
  }

  .news_line {
    padding: 0 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/enViews/news/newsInfo.vue